var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs is-medium"},[_c('ul',[_c('li',{class:{
                'is-active': _vm.$route.name === 'account.settings',
            }},[_c('router-link',{attrs:{"to":{ name: 'account.settings' }}},[_vm._v(" Profile ")])],1),_c('li',{class:{
                'is-active': _vm.$route.name === 'account.settings.sites',
            }},[_c('router-link',{attrs:{"to":{ name: 'account.settings.sites' }}},[_vm._v(" Sites ")])],1),_c('li',{class:{
                'is-active': _vm.$route.name === 'account.settings.script',
            }},[_c('router-link',{attrs:{"to":{ name: 'account.settings.script' }}},[_vm._v(" Recording Script ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }